<template>
  <ReferenceMultipleSelect
    v-model="directions"
    class="ma-0"
    label="Направление"
    resource="countries"
    @input="changeDirections"
  />
</template>

<script>
export default {
  computed: {
    directions: {
      get() {
        return this.$store.getters["routePlanning/directions"];
      },
      set(value) {
        return this.$store.commit("routePlanning/setDirections", value);
      },
    },
  },

  methods: {
    changeDirections(value) {
      this.$store.commit("routePlanning/setDirections", value);
      this.$store.commit("routePlanning/setFilterIsActive", true);
      this.$emit("input");
    },
  },
};
</script>
